import { ref } from 'vue'

type NotificationType = 'SUCCESS' | 'ERROR' | 'WARNING' | 'INFO'

interface Notification {
  id: string
  message: string
  type: NotificationType
  timeout?: number
}

const notifications = ref<Notification[]>([])

export function useNotification() {
  const notify = ({ 
    message, 
    type = 'INFO', 
    timeout = 5000 
  }: { 
    message: string
    type?: NotificationType
    timeout?: number 
  }) => {
    const id = Math.random().toString(36).substring(2)
    const notification: Notification = {
      id,
      message,
      type,
      timeout
    }

    notifications.value.push(notification)

    if (timeout > 0) {
      setTimeout(() => {
        removeNotification(id)
      }, timeout)
    }

    return id
  }

  const removeNotification = (id: string) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index !== -1) {
      notifications.value.splice(index, 1)
    }
  }

  return {
    notifications,
    notify,
    removeNotification
  }
} 